export class ScrollArrow {
  private element: HTMLElement;
  private hasScrolled = false;
  private inactivityTimer: number | null = null;
  private initialShowTimer: number | null = null;
  private isInSpaceMode = false;

  constructor() {
    this.element = document.getElementById("scroll-arrow") as HTMLElement;
    if (!this.element) {
      console.warn("Scroll arrow element not found");
      return;
    }

    this.init();
  }

  private init() {
    // Show arrow after 2 seconds of page load
    this.initialShowTimer = window.setTimeout(() => {
      if (!this.hasScrolled && !this.isInSpaceMode) {
        this.show();
      }
    }, 2000);

    // Listen for scroll events
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  private handleScroll() {
    // Mark that user has scrolled
    this.hasScrolled = true;

    // Hide the arrow when scrolling
    this.hide();

    // Clear existing inactivity timer
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }

    // Set new inactivity timer (5 seconds)
    this.inactivityTimer = window.setTimeout(() => {
      // Show arrow again if not in space mode
      if (!this.isInSpaceMode) {
        this.show();
      }
    }, 5000);
  }

  private show() {
    if (this.isInSpaceMode) return;

    this.element.classList.remove("display-none");
    // Small delay to trigger CSS transition
    requestAnimationFrame(() => {
      this.element.classList.add("visible");
    });
  }

  private hide() {
    this.element.classList.remove("visible");
    // Wait for transition to complete before hiding
    setTimeout(() => {
      if (!this.element.classList.contains("visible")) {
        this.element.classList.add("display-none");
      }
    }, 500); // Match CSS transition duration
  }

  /**
   * Call this when entering space mode to permanently hide the arrow
   */
  enterSpaceMode() {
    this.isInSpaceMode = true;
    this.hide();

    // Clear all timers
    if (this.initialShowTimer) {
      clearTimeout(this.initialShowTimer);
      this.initialShowTimer = null;
    }
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
  }

  /**
   * Cleanup method
   */
  dispose() {
    window.removeEventListener("scroll", this.handleScroll.bind(this));
    if (this.initialShowTimer) {
      clearTimeout(this.initialShowTimer);
    }
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
  }
}

export default ScrollArrow;
